import { useLocation } from 'react-router-dom';

import QuizBreadcrumbs from './components/QuizBredcrumbs/QuizBreadcrumbs';
import StudyBreadcrumbs from './components/StudyBredcrumbs/StudyBreadcrumbs';

const ShowBreadcrumbs = () => {
  const { pathname } = useLocation();
  return (
    <>
      {pathname.startsWith('/study/') && <StudyBreadcrumbs />}
      {pathname.startsWith('/quiz/') && <QuizBreadcrumbs />}
    </>
  );
};

export default ShowBreadcrumbs;
